export default {
	message: 'Proszę kliknąć przycisk Synchronizuj, aby dodać nowe konta z SM do naszego systemu!',
	selector: 'Wybierz akcję',
	button: 'Synchronizuj'
};
